import Img from './../Img'
import Search from '../search/Search'

const PageSummary = (): JSX.Element => {
  return (
    <div className="pb-10 pt-32 h-fit min-h-[40vh] xl:h-[90vh] relative">
      <Img
        src='/landingbg1.png'
        alt='Landing page background'
        className='-z-10 absolute top-0 left-0 w-full h-full min-h-[40vh] xl:h-[90vh] brightness-75'
      />
      <div className='Overlay z-20 w-full h-full flex flex-col md:flex-row lg:flex-col xl:flex-row items-center justify-around  pb-10 gap-5'>
        <div className='TextContent flex flex-col gap-2'>
          <h1 className='MainTitle text-[1.7rem] lg:text-[2rem] xl:text-[3rem] px-10 max-w-[1000px] xl:max-w-[400px] 2xl:max-w-[600px] xl:leading-[3rem] font-bold'>
            <span className='WhiteText text-white'>Book your next </span>
            <span className='GoldenText text-gold'>home, restaurant, car</span>
            <span className='WhiteText text-white'> in Rwanda</span>
          </h1>
          <p className='text-white px-10 max-w-[1000px] xl:max-w-[400px] font-light'>
            Are  you willing to travel to Rwanda, you have to prepare everything like accomodations and transport services even dinning services before your come. We're here to help you in that.
          </p>
        </div>
        <Search />
      </div>
    </div>
  )
}

export default PageSummary